import React, { useState } from "react";
import "../../Styles/AdminPressTable.css";
import { useNavigate } from "react-router-dom";

function AdminPressTable() {
  const navigate = useNavigate();

  const initialData = [
    {
      id: 1,
      title: "Press Event 1",
      image: "https://picsum.photos/seed/press1/300/200",
      dateAdded: "20-07-2026",
      status: "Active",
      views: 210,
    },
    {
      id: 2,
      title: "Press Event 2",
      image: "https://picsum.photos/seed/press2/300/200",
      dateAdded: "18-07-2026",
      status: "Active",
      views: 145,
    },
    {
      id: 3,
      title: "Press Event 3",
      image: "https://picsum.photos/seed/press3/300/200",
      dateAdded: "10-06-2026",
      status: "Active",
      views: 302,
    },
    {
      id: 4,
      title: "Press Event 4",
      image: "https://picsum.photos/seed/press4/300/200",
      dateAdded: "02-06-2026",
      status: "Inactive",
      views: 88,
    },
    {
      id: 5,
      title: "Press Event 5",
      image: "https://picsum.photos/seed/press5/300/200",
      dateAdded: "28-05-2026",
      status: "Active",
      views: 176,
    },
  ];

  const [pressItems, setPressItems] = useState(initialData);

  const [search, setSearch] = useState("");
  const [dateFilter, setDateFilter] = useState("All Dates");
  const [status, setStatus] = useState("All Status");
  const [currentPage, setCurrentPage] = useState(1);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const totalPages = 5;

  const resetFilters = () => {
    setSearch("");
    setDateFilter("All Dates");
    setStatus("All Status");
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // ---------- SEARCH + FILTER LOGIC ----------
  const filteredPress = pressItems.filter((item) => {
    const searchLower = search.trim().toLowerCase();

    const matchesSearch =
      searchLower === "" || item.title.toLowerCase().includes(searchLower);

    const matchesStatus = status === "All Status" || item.status === status;

    let matchesDate = true;
    if (dateFilter === "This Month") {
      const today = new Date();
      const [day, month, year] = item.dateAdded.split("-").map(Number);
      matchesDate =
        month === today.getMonth() + 1 && year === today.getFullYear();
    } else if (dateFilter === "This Year") {
      const today = new Date();
      const [, , year] = item.dateAdded.split("-").map(Number);
      matchesDate = year === today.getFullYear();
    }

    return matchesSearch && matchesStatus && matchesDate;
  });

  // ---------- EDIT LOGIC ----------
  const openEditModal = (item) => {
    setEditItem({ ...item });
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditItem(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = (e) => {
    e.preventDefault();
    setPressItems((prev) =>
      prev.map((item) => (item.id === editItem.id ? editItem : item))
    );
    closeEditModal();
  };

  // ---------- STATS ----------
  const totalPress = pressItems.length;
  const totalViews = pressItems.reduce((sum, p) => sum + p.views, 0);
  const activeCount = pressItems.filter((p) => p.status === "Active").length;

  const recentlyAdded = pressItems.filter((p) => {
    const today = new Date();
    const [day, month, year] = p.dateAdded.split("-").map(Number);
    return month === today.getMonth() + 1 && year === today.getFullYear();
  }).length;

  return (
    <div className="adminpress12-page">
      {/* Header */}
      <div className="adminpress12-header">
        <div className="adminpress12-header-left">
          <div className="adminpress12-page-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <path d="M7 8h10M7 12h10M7 16h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              <path d="M3 20h18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </div>
          <div>
            <h2 className="adminpress12-title">Press</h2>
            <p className="adminpress12-subtitle">
              Manage and organize all your press coverage photos
            </p>
          </div>
        </div>

        <button
          className="adminpress12-add-btn"
          onClick={() => navigate("/AdminDashboard/AdminPressForm")}
        >
          <span className="adminpress12-add-icon">+</span> Add Press Photo
        </button>
      </div>

      {/* Stat Cards */}
      <div className="adminpress12-stats-grid">
        <div className="adminpress12-stat-card">
          <div className="adminpress12-stat-icon adminpress12-stat-icon-green">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <path d="M7 8h10M7 12h10M7 16h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </div>
          <div className="adminpress12-stat-info">
            <span className="adminpress12-stat-label">Total Press Photos</span>
            <span className="adminpress12-stat-value">{totalPress}</span>
            <span className="adminpress12-stat-sub">All time photos</span>
          </div>
        </div>

        <div className="adminpress12-stat-card">
          <div className="adminpress12-stat-icon adminpress12-stat-icon-purple">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
              <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
            </svg>
          </div>
          <div className="adminpress12-stat-info">
            <span className="adminpress12-stat-label">Total Views</span>
            <span className="adminpress12-stat-value">
              {totalViews.toLocaleString()}
            </span>
            <span className="adminpress12-stat-sub">All time views</span>
          </div>
        </div>

        <div className="adminpress12-stat-card">
          <div className="adminpress12-stat-icon adminpress12-stat-icon-orange">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </div>
          <div className="adminpress12-stat-info">
            <span className="adminpress12-stat-label">Recently Added</span>
            <span className="adminpress12-stat-value">{recentlyAdded}</span>
            <span className="adminpress12-stat-sub">This month</span>
          </div>
        </div>

        <div className="adminpress12-stat-card">
          <div className="adminpress12-stat-icon adminpress12-stat-icon-blue">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
            </svg>
          </div>
          <div className="adminpress12-stat-info">
            <span className="adminpress12-stat-label">Active</span>
            <span className="adminpress12-stat-value">{activeCount}</span>
            <span className="adminpress12-stat-sub">Currently published</span>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="adminpress12-filters">
        <div className="adminpress12-search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
            <path d="M21 21l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            placeholder="Search by press title..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <select
          className="adminpress12-select"
          value={dateFilter}
          onChange={(e) => {
            setDateFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Dates</option>
          <option>This Month</option>
          <option>This Year</option>
        </select>

        <select
          className="adminpress12-select"
          value={status}
          onChange={(e) => {
            setStatus(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Status</option>
          <option>Active</option>
          <option>Inactive</option>
        </select>

        <button className="adminpress12-reset-btn" onClick={resetFilters}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 4v6h6M20 20v-6h-6M4.5 15a8 8 0 0014.5 3.5M19.5 9A8 8 0 005 5.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Reset Filters
        </button>
      </div>

      {/* Table */}
      <div className="adminpress12-table-wrapper">
        <table className="adminpress12-table table table-hover">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Photo</th>
              <th>Date Added</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredPress.length === 0 ? (
              <tr>
                <td colSpan="5" className="adminpress12-no-data">
                  No press photos found.
                </td>
              </tr>
            ) : (
              filteredPress.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>

                  <td>
                    <div className="adminpress12-photo-cell">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="adminpress12-thumb"
                      />
                      <span className="adminpress12-photo-title">
                        {item.title}
                      </span>
                    </div>
                  </td>

                  <td>
                    <div className="adminpress12-date-cell">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
                        <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      </svg>
                      {item.dateAdded}
                    </div>
                  </td>

                  <td>
                    <span
                      className={`adminpress12-status-badge ${
                        item.status === "Active"
                          ? "adminpress12-status-active"
                          : "adminpress12-status-inactive"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <button
                      className="adminpress12-edit-btn"
                      onClick={() => openEditModal(item)}
                    >
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="adminpress12-pagination-bar">
        <span className="adminpress12-pagination-info">
          Showing 1 to {filteredPress.length} of {totalPress} photos
        </span>

        <div className="adminpress12-pagination-controls">
          <button
            className="adminpress12-page-arrow"
            onClick={() => handlePageChange(currentPage - 1)}
          >
            &lt;
          </button>

          {[1, 2, 3].map((p) => (
            <button
              key={p}
              className={`adminpress12-page-num ${
                currentPage === p ? "adminpress12-active" : ""
              }`}
              onClick={() => handlePageChange(p)}
            >
              {p}
            </button>
          ))}

          <span className="adminpress12-page-dots">...</span>

          <button
            className={`adminpress12-page-num ${
              currentPage === totalPages ? "adminpress12-active" : ""
            }`}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>

          <button
            className="adminpress12-page-arrow"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            &gt;
          </button>
        </div>
      </div>

      {/* ---------------- EDIT MODAL ---------------- */}
      {showEditModal && editItem && (
        <div className="adminpress12-modal-overlay" onClick={closeEditModal}>
          <div className="adminpress12-modal" onClick={(e) => e.stopPropagation()}>
            <div className="adminpress12-modal-header">
              <h3>Edit Press Photo</h3>
              <button className="adminpress12-modal-close" onClick={closeEditModal}>
                &times;
              </button>
            </div>

            <form className="adminpress12-modal-body" onSubmit={handleEditSave}>
              <div className="adminpress12-form-row">
                <div className="adminpress12-form-group">
                  <label>Press Title</label>
                  <input
                    type="text"
                    name="title"
                    value={editItem.title}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="adminpress12-form-group">
                  <label>Status</label>
                  <select
                    name="status"
                    value={editItem.status}
                    onChange={handleEditChange}
                  >
                    <option>Active</option>
                    <option>Inactive</option>
                  </select>
                </div>
              </div>

              <div className="adminpress12-form-group">
                <label>Date Added</label>
                <input
                  type="text"
                  name="dateAdded"
                  placeholder="DD-MM-YYYY"
                  value={editItem.dateAdded}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="adminpress12-modal-footer">
                <button
                  type="button"
                  className="adminpress12-btn-cancel"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button type="submit" className="adminpress12-btn-save">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminPressTable;